import { Expose, Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { PlusAppliesOnEnum, PlusCountingUnitEnum } from "@altertec_gparn/lib";
import { PlusHasTaskTypeDto } from "@/core/features/pluses/plus-has-task-type.dto";
import { OperativeUnitDto } from "@/core/features/operative-units/operative-unit.dto";
import { toEuros, toHours } from "@/utils/numberUtils";

export class PlusDto extends BaseEntityDto {
  @Expose()
  name: string;

  @Expose()
  description?: string | null;

  @Expose()
  @Transform(({ value }) => toEuros(value))
  defaultUnitPrice: number;

  @Expose()
  countingUnit: PlusCountingUnitEnum;

  @Expose()
  appliesOn?: PlusAppliesOnEnum | null;

  @Expose()
  @Transform(({ value }) => (value === null || value === undefined ? null : toHours(value)))
  minimumWorkedMinutes?: number | null;

  @Expose()
  isActive: boolean;

  @Expose()
  appliesToCompany: boolean;

  @Expose()
  operativeUnitId?: string | null;

  @Expose()
  appliesToProjectOperativeUnit: boolean;

  @Expose()
  @Type(() => OperativeUnitDto)
  operativeUnit?: OperativeUnitDto | null;

  @Expose()
  @Type(() => PlusHasTaskTypeDto)
  plusHasTaskTypes?: PlusHasTaskTypeDto[];

  @Expose()
  payrollConceptKey?: string | null;
}
